import { render, staticRenderFns } from "./outbox.vue?vue&type=template&id=6ad2bb92&scoped=true&"
import script from "./outbox.vue?vue&type=script&lang=js&"
export * from "./outbox.vue?vue&type=script&lang=js&"
import style0 from "./outbox.vue?vue&type=style&index=0&id=6ad2bb92&scoped=true&lang=scss&"
import style1 from "./outbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2bb92",
  null
  
)

export default component.exports